/**
 * @generated SignedSource<<f9e17fea6771f25b035654efe51153f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CompanyUsersProviderQuery$variables = {};
export type CompanyUsersProviderQuery$data = {
  readonly allUserCompanyRoles: ReadonlyArray<{
    readonly apaduaRole: string | null;
    readonly apalyticsRole: string | null;
    readonly briefRole: string | null;
    readonly email: string | null;
    readonly exploreRole: string | null;
    readonly isActive: boolean | null;
    readonly isUserManager: boolean | null;
    readonly monitorRole: string | null;
    readonly profileCompleted: boolean | null;
    readonly registrationCompleted: boolean | null;
    readonly user: {
      readonly firstName: string;
      readonly id: string;
      readonly lastName: string;
    } | null;
  } | null> | null;
};
export type CompanyUsersProviderQuery = {
  response: CompanyUsersProviderQuery$data;
  variables: CompanyUsersProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UserCompanyRolesNode",
    "kind": "LinkedField",
    "name": "allUserCompanyRoles",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "registrationCompleted",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "profileCompleted",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "briefRole",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "apaduaRole",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "exploreRole",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "apalyticsRole",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "monitorRole",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActive",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isUserManager",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CompanyUsersProviderQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CompanyUsersProviderQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "71d28410d0e768c97011624f61b0731d",
    "id": null,
    "metadata": {},
    "name": "CompanyUsersProviderQuery",
    "operationKind": "query",
    "text": "query CompanyUsersProviderQuery {\n  allUserCompanyRoles {\n    user {\n      id\n      firstName\n      lastName\n    }\n    email\n    registrationCompleted\n    profileCompleted\n    briefRole\n    apaduaRole\n    exploreRole\n    apalyticsRole\n    monitorRole\n    isActive\n    isUserManager\n  }\n}\n"
  }
};
})();

(node as any).hash = "eccaa13a175243f21d86f1f1b9f88840";

export default node;
